import { render, staticRenderFns } from "./TechnologyPartner.update.vue?vue&type=template&id=5c9bc4ee&scoped=true"
import script from "./TechnologyPartner.update.vue?vue&type=script&lang=js"
export * from "./TechnologyPartner.update.vue?vue&type=script&lang=js"
import style0 from "./TechnologyPartner.update.vue?vue&type=style&index=0&id=5c9bc4ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9bc4ee",
  null
  
)

export default component.exports